/**
 * @generated SignedSource<<f78d667514536adb83846631f56e2b77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
export type MicrosoftTodoIntegrationQuery$variables = {};
export type MicrosoftTodoIntegrationQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessToMicrosoftTodoIntegration: boolean;
      };
    };
    readonly integrations: {
      readonly asana: {
        readonly connectedProject: {
          readonly id: string;
        } | null;
      } | null;
      readonly microsoftTodo: {
        readonly id: string;
        readonly isConnected: boolean;
        readonly unsyncedActionItemCount: number;
      } | null;
      readonly userLevelActionItemIntegration: {
        readonly id: string;
        readonly integrationProvider: IntegrationProvider;
        readonly integrationSpecificDetails: {
          readonly externalListId?: string;
          readonly externalListName?: string;
          readonly id?: string;
        };
        readonly lastSyncDate: string | null;
        readonly syncEnabled: boolean | null;
        readonly syncedActionItemCount: number | null;
        readonly unsyncedActionItemCount: number | null;
      } | null;
    };
  };
};
export type MicrosoftTodoIntegrationQuery = {
  response: MicrosoftTodoIntegrationQuery$data;
  variables: MicrosoftTodoIntegrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "hasAccessToMicrosoftTodoIntegration",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "microsoft_todo_integration"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"microsoft_todo_integration\")"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unsyncedActionItemCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MicrosoftTodoUserNode",
  "kind": "LinkedField",
  "name": "microsoftTodo",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isConnected",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = [
  (v1/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AsanaProjectNode",
  "kind": "LinkedField",
  "name": "connectedProject",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationProvider",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "syncEnabled",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "syncedActionItemCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSyncDate",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalListName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalListId",
      "storageKey": null
    }
  ],
  "type": "MicrosoftTodoUserIntegrationNode",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MicrosoftTodoIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserActionItemIntegrationNode",
                "kind": "LinkedField",
                "name": "userLevelActionItemIntegration",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v2/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integrationSpecificDetails",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MicrosoftTodoIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserActionItemIntegrationNode",
                "kind": "LinkedField",
                "name": "userLevelActionItemIntegration",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v2/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integrationSpecificDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v4/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "80271566ded1b705d299de35b6387940",
    "id": null,
    "metadata": {},
    "name": "MicrosoftTodoIntegrationQuery",
    "operationKind": "query",
    "text": "query MicrosoftTodoIntegrationQuery {\n  viewer {\n    account {\n      billingAccount {\n        hasAccessToMicrosoftTodoIntegration: hasAccessToFeature(feature: microsoft_todo_integration)\n        id\n      }\n      id\n    }\n    integrations {\n      microsoftTodo {\n        id\n        isConnected\n        unsyncedActionItemCount\n      }\n      asana {\n        connectedProject {\n          id\n        }\n        id\n      }\n      userLevelActionItemIntegration {\n        id\n        integrationProvider\n        syncEnabled\n        syncedActionItemCount\n        unsyncedActionItemCount\n        lastSyncDate\n        integrationSpecificDetails {\n          __typename\n          ... on MicrosoftTodoUserIntegrationNode {\n            id\n            externalListName\n            externalListId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3e5a795cb4ca4c2cfce245a417a47e31";

export default node;
